// extracted by mini-css-extract-plugin
module.exports = {"leadMediaThumb":"project-preview-module--leadMediaThumb--3xciV"};